import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import ViewDocModal from "../../Modals/viewDocModel";
import PdfPreviewModal from "../../Modals/pdfPreviewModal";
import {
  Box,
  Tabs,
  Tab,
  TextField,
  Button,
  CardMedia,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  IconButton,
  Grid,
  Typography,
  Autocomplete,
  Checkbox,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { ChangeEvent, useEffect, useState } from "react";
import "react-phone-input-2/lib/bootstrap.css";
import AddIcon from "@mui/icons-material/Add";
import PhoneInput from "react-phone-input-2";
import {
  useLazyGetEmployerByIdQuery,
  useUpdateEmployerMutation,
} from "../../services/users";
import { Employer, FreelancerData, Document } from "../../types/General";
import { showError, showToast } from "../../constants/toasts";
import { UploadMedia } from "../../utils/mediaUpload";
import { isString, isValidInput } from "../../utils/validations";
import useTranslation from "../../hooks/traslation";
import { CERTIFICATE_TYPE, SECURITY_DOC_TYPE, SKILLS } from "../../utils/enums";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const DOCUMENT_TYPE = {
  CERTIFICATE: 1,
  SECURITY: 2,
} as const;

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface ExtendedDocument extends Document {
  documentId?: string;
}

interface ProfInfo {
  industryExperience: any[];
  skills: number[];
  days: string[];
  _id: string;
  userId: string;
  startTime: string;
  endTime: string;
  createdAt: string;
  updatedAt: string;
}

interface ExtendedFreelancerData extends FreelancerData {
  profInfo: ProfInfo;
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const AddTeam = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [getDataById] = useLazyGetEmployerByIdQuery();
  const [updateEmployer] = useUpdateEmployerMutation();

  const [valueTabs, setValueTabs] = useState(0);
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState<Employer | null>(null);
  const [doc, setDoc] = useState<any>([]);
  const [civilIdFile, setCivilIdFile] = useState<File | null>(null);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [alertMessage, setAlertMessage] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [civilIdImage, setCivilIdImage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [phone, setPhone] = useState("");
  const [dialCode, setDialCode] = useState("+971");
  const [error, setError] = useState(false);
  const [data, setData] = useState<ExtendedFreelancerData | null>(null);
  const [editingDoc, setEditingDoc] = useState<{
    id: string;
    link: string;
  } | null>(null);
  const [selectedDocUrl, setSelectedDocUrl] = useState("");
  const [openDocView, setOpenDocView] = useState(false);
  const [certificateDocs, setCertificateDocs] = useState<ExtendedDocument[]>(
    []
  );
  const [securityDocs, setSecurityDocs] = useState<ExtendedDocument[]>([]);
  const [prevSecurityDocs, setPrevSecurityDocs] = useState<ExtendedDocument[]>(
    []
  );
  const [prevCertificateDocs, setPrevCertificateDocs] = useState<
    ExtendedDocument[]
  >([]);
  const [selectedSkills, setSelectedSkills] = useState<number[]>([]);
  const [openPdfPreview, setOpenPdfPreview] = useState(false);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState("");

  const handleChangeCountry = (event: any) => {
    setSelectedCountry(event.target.value);
  };

  const handleChangePhone = (phone: any, country: any) => {
    setPhone(phone?.replace(country.dialCode, ""));
    setDialCode(country?.dialCode);
  };
  const [selectField1, setSelectField1] = React.useState("default");
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };
  const handleNextTab = () => {
    setValueTabs((prevIndex) => prevIndex + 1);
  };

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: detail?.firstName || "",
      lastName: detail?.lastName || "",
      address: detail?.address || "",
      email: detail?.email || "",
    },

    validationSchema: Yup.object({
      name: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),
      email: Yup.string()
        .required("Email is required!")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Please enter a valid email address!"
        ),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);
      if (phone.length < 5) return;

      const documents = [
        ...certificateDocs.map((doc) => ({
          documentId: doc.documentId,
          link: doc.link,
          type: doc.type,
        })),
        ...securityDocs.map((doc) => ({
          documentId: doc.documentId,
          link: doc.link,
          type: doc.type,
        })),
      ];

      let body = {
        ...(profileImage ? { image: profileImage } : {}),
        firstName: values?.name || "",
        lastName: values?.lastName || "",
        phoneNo: phone || "",
        email: values?.email || "",
        dialCode: (dialCode.includes("+") ? "" : "+") + dialCode,
        documents: documents,
        skills: selectedSkills.map((skill) => Number(skill)),
      };

      try {
        let response;
        if (id) {
          response = await updateEmployer({ id, body }).unwrap();
        }
        if (response?.statusCode === 200) {
          showToast(
            id
              ? "Freelancer updated successfully"
              : "Freelancer added successfully"
          );
          navigate(
            `/manage-freelancer?tab=${
              detail?.approveStatus ? detail?.approveStatus - 1 : "0"
            }`
          );
        }
      } catch (error: any) {
        showError(error?.data?.message || "");
        console.log(error);
      }
    },
  });

  const openPdfInNewTab = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const renderDocumentPreview = (doc: ExtendedDocument) => {
    const isPdf = doc.link?.toLowerCase().endsWith(".pdf");
    const isImage = doc.link
      ?.toLowerCase()
      .match(/\.(jpg|jpeg|png|gif|bmp|webp)$/);

    if (isPdf) {
      return (
        <div className="upload_image no_radius v2">
          <div className="upload_image_holder">
            <Button
              onClick={() => {
                const pdfUrl = encodeURI(doc.link);
                setSelectedPdfUrl(pdfUrl);
                setOpenPdfPreview(true);
              }}
              style={{
                textDecoration: "none",
                color: "inherit",
                width: "100%",
                height: "100%",
                display: "flex",

                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <figure
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  margin: 0,
                }}
              >
                <PictureAsPdfIcon style={{ fontSize: 48, color: "#f44336" }} />
                <Typography variant="body2" style={{ marginTop: 8 }}>
                  View PDF
                </Typography>
              </figure>
            </Button>
          </div>
        </div>
      );
    }

    if (isImage) {
      return (
        <div
          className="upload_image no_radius v2"
          onClick={() => {
            setOpenDocView(true);
            setSelectedDocUrl(doc.link);
          }}
        >
          <div className="upload_image_holder">
            <figure>
              <CardMedia component="img" image={doc.link} alt="document" />
            </figure>
          </div>
        </div>
      );
    }

    return null;
  };

  const handleProfileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setProfileImage("");
      return;
    }
    if (
      file &&
      file.type &&
      file.type !== "image/jpeg" &&
      file.type !== "image/jpg" &&
      file.type !== "image/png"
    ) {
      showError("Please upload the image in the JPG, JPEG or PNG format");
      return;
    }

    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data) {
      setProfileImage(imageUrl?.data?.image || "");
    }
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
    type: "certificate" | "security",
    docType: number,
    docId?: string
  ) => {
    const files = event.target.files;
    if (!files) return;

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
    ];
    const invalidFiles = Array.from(files).filter(
      (file) => !allowedTypes.includes(file.type)
    );

    if (invalidFiles.length > 0) {
      showError(
        "Invalid file type. Please upload PNG, JPEG, JPG or PDF files."
      );
      event.target.value = "";
      return;
    }

    try {
      const uploadPromises = Array.from(files).map((file) => UploadMedia(file));
      const responses = await Promise.all(uploadPromises);

      const newDocs = responses.map((res) => ({
        _id: docId || res?.data?._id,
        documentId: docId || res?.data?._id,
        link: res?.data?.image || res?.data?.link,
        type: docType,
        docType:
          type === "certificate"
            ? DOCUMENT_TYPE.CERTIFICATE
            : DOCUMENT_TYPE.SECURITY,
      }));

      if (type === "certificate") {
        setCertificateDocs((prev) => {
          const filtered = prev.filter((doc) => doc._id !== docId);
          return [...filtered, ...newDocs];
        });
      } else {
        setSecurityDocs((prev) => {
          const filtered = prev.filter((doc) => doc._id !== docId);
          return [...filtered, ...newDocs];
        });
      }

      event.target.value = "";
    } catch (error) {
      console.error("Document Upload Error:", error);
      showError("Error uploading files");
      event.target.value = "";
    }
  };

  useEffect(() => {
    if (detail?.phoneNo) {
      setPhone(detail?.phoneNo || "");
      setProfileImage(detail?.image || "");
      setDialCode(detail?.dialCode || "");
    }
  }, [detail]);

  useEffect(() => {
    if (data) {
      const formattedCertificateDocs = (data.certificateDocs || []).map(
        (doc) => ({
          ...doc,
          documentId: doc._id,
          docType: DOCUMENT_TYPE.CERTIFICATE,
        })
      );
      const formattedSecurityDocs = (data.securityDocs || []).map((doc) => ({
        ...doc,
        documentId: doc._id,
        docType: DOCUMENT_TYPE.SECURITY,
      }));
      setCertificateDocs(formattedCertificateDocs);
      setSecurityDocs(formattedSecurityDocs);
    }
  }, [data]);

  useEffect(() => {
    if (data?.profInfo?.skills) {
      setSelectedSkills(data.profInfo.skills);
    }
  }, [data]);

  const getData = async (id: string) => {
    setLoading(true);
    try {
      const response = await getDataById({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setDetail(response?.data?.user || null);
        setData(response?.data);
        setPrevSecurityDocs(response?.data?.securityDocs);
        setPrevCertificateDocs(response?.data?.certificateDocs);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, []);

  const translation = useTranslation();

  const handleSubmitDocuments = async () => {
    const allDocuments = [...certificateDocs, ...securityDocs];
    formik.setFieldValue("documents", allDocuments);

    const requestBody = {
      documents: allDocuments.map((doc) => ({
        documentId: doc.documentId || doc._id,
        link: doc.link,
        type: doc.type,
        docType: doc.docType,
      })),
    };

    try {
      const response = await updateEmployer({
        id: id || "",
        body: requestBody,
      }).unwrap();

      if (response.statusCode === 200) {
        showToast("Documents updated successfully");
        navigate(
          `/manage-freelancer?tab=${
            detail?.approveStatus ? detail?.approveStatus - 1 : "0"
          }`
        );
      }
    } catch (error: any) {
      console.error("Documents Update Error:", error);
      showError(error?.data?.message || "");
    }
  };

  const getDocumentTypeLabel = (
    type: number,
    docType: "certificate" | "security"
  ) => {
    if (docType === "certificate") {
      return type === CERTIFICATE_TYPE.EDUCATION
        ? "Education Certificate"
        : "Training Certificate";
    } else {
      return type === SECURITY_DOC_TYPE.CIVIL_ID
        ? "Civil ID"
        : "Driving License";
    }
  };

  return (
    <MainContainer>
      <div className="main_title">
        <h1>{id ? translation.main.editFrancer : "Add Freelancer"} </h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>
            {translation.dashboard.dashboard}
          </span>{" "}
          -{" "}
          <span
            onClick={() =>
              navigate(
                `/manage-freelancer?tab=${
                  detail?.approveStatus ? detail?.approveStatus - 1 : "0"
                }`
              )
            }
          >
            {translation.main.manageFreelancer}
          </span>{" "}
          - {id ? translation.main.editFrancer : "Add Freelancer"}
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs1" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Basic Info" {...a11yProps(0)} />
            <Tab label="Documents" {...a11yProps(1)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form" onSubmit={formik.handleSubmit}>
            <div className="gap_p">
              <div className="control_group w_100">
                <label> {translation.main.uploadImage}</label>
                {profileImage ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia
                          component="img"
                          image={
                            profileImage
                              ? profileImage
                              : "/static/images/user_placeholder.png"
                          }
                          alt="photo"
                        />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setProfileImage("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg,image/jpg",
                      }}
                      onChange={(e: any) => {
                        handleProfileUpload(e);
                        e.target.value = null;
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/user_placeholder.png"
                          alt="icon"
                        />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
              <div className="control_group w_50">
                <label> {translation.main.firstName}</label>
                <TextField
                  placeholder={translation.main.firstName}
                  variant="outlined"
                  className="text_field"
                  fullWidth
                  hiddenLabel
                  name="name"
                  id="name"
                  inputProps={{ maxLength: 40 }}
                  value={formik.values.name}
                  onChange={(val) => {
                    if (
                      isValidInput(val.target.value) &&
                      isString(val.target.value)
                    ) {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.name && (formik.errors.name as string)
                  }
                />
              </div>

              <div className="control_group w_50">
                <label> {translation.main.lastName}</label>
                <TextField
                  placeholder={translation.main.lastName}
                  variant="outlined"
                  className="text_field"
                  fullWidth
                  hiddenLabel
                  name="lastName"
                  id="lastName"
                  inputProps={{ maxLength: 40 }}
                  value={formik.values.lastName}
                  onChange={(val) => {
                    if (
                      isValidInput(val.target.value) &&
                      isString(val.target.value)
                    ) {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  // helperText={formik.touched.lastName && formik.errors.lastName}
                />
              </div>

              <div className="control_group w_50">
                <label> {translation.main.email}</label>
                <TextField
                  placeholder={translation.main.email}
                  hiddenLabel
                  fullWidth
                  className="text_field"
                  name="email"
                  id="email"
                  inputProps={{ maxLength: 80 }}
                  value={formik.values.email}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.email && (formik.errors.email as any)
                  }
                />
              </div>
              <div className="control_group w_50">
                <label> {translation.main.phone}</label>
                <PhoneInput
                  enableSearch
                  value={dialCode + phone}
                  country={"uae"}
                  inputClass="phoneInput"
                  onChange={(phone, country) =>
                    handleChangePhone(phone, country)
                  }
                  inputStyle={{ width: "100%" }}
                  buttonClass="phoneBtn"
                  placeholder={translation.main.phone}
                />
                {!phone && error ? (
                  <h6 className="err_msg">{translation.error.required}</h6>
                ) : (
                  ""
                )}
                {phone.length >= 1 && phone.length < 5 && error ? (
                  <h6 className="err_msg">{translation.error.validphone}</h6>
                ) : (
                  ""
                )}
              </div>
              <div className="control_group w_50">
                <label>Skills</label>
                <Autocomplete
                  className="users_autocomplete"
                  multiple
                  options={Object.entries(SKILLS)
                    .filter(([key]) => isNaN(Number(key)))
                    .map(([key, value]) => ({ name: key, _id: Number(value) }))}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.name}
                  value={Object.entries(SKILLS)
                    .filter(([key]) => isNaN(Number(key)))
                    .map(([key, value]) => ({ name: key, _id: Number(value) }))
                    .filter((s) => selectedSkills.includes(Number(s._id)))}
                  onChange={(event, newValue) => {
                    const selectedIds = newValue.map((item) =>
                      Number(item._id)
                    );
                    setSelectedSkills(selectedIds);
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option._id === value._id
                  }
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Skills"
                      fullWidth
                      className="text_field"
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option.name}
                        {...getTagProps({ index })}
                        key={option._id}
                      />
                    ))
                  }
                  clearOnBlur={false}
                  clearIcon
                />
              </div>
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  formik.validateForm().then((errors) => {
                    if (Object.keys(errors).length === 0) {
                      handleNextTab();
                    }
                  });
                }}
              >
                Next
              </Button>
            </div>
          </form>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={1}>
          <div className="form">
            {/* <div className="single_doc">
              <Grid container spacing={2}>
                <Grid item xs={12} className="heading">
                  <Typography className="document_head" variant="h5">
                    Certificate Documents
                  </Typography>
                </Grid>
                {certificateDocs.length === 0 ? (
                  <Grid item xs={12}>
                    <Typography variant="body1" style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                      No certificate documents available
                    </Typography>
                  </Grid>
                ) : (
                  certificateDocs.map((doc, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={doc._id || index}>
                      <div className="control_group">
                        <Typography className="custom_label">
                          {getDocumentTypeLabel(doc.type, "certificate")}
                        </Typography>
                        <Box className="docs_div v2">
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <div className="doc_preview_container" style={{ position: "relative" }}>
                                {renderDocumentPreview(doc)}
                                <label
                                  className="upload_image no_radius v2"
                                  htmlFor={`icon-button-file-certificate-${doc.type}-${doc._id}`}
                                  style={{
                                    position: "absolute",
                                    bottom: 8,
                                    right: 8,
                                    width: "32px",
                                    height: "32px",
                                    minWidth: "32px",
                                    padding: 0,
                                    borderRadius: "50%",
                                    backgroundColor: "rgba(255,255,255,0.9)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                  }}
                                >
                                  <Input
                                    sx={{ display: "none" }}
                                    id={`icon-button-file-certificate-${doc.type}-${doc._id}`}
                                    type="file"
                                    inputProps={{
                                      accept: "image/png,image/jpeg,application/pdf",
                                    }}
                                    onChange={(event: any) => {
                                      handleImageUpload(
                                        event,
                                        "certificate",
                                        doc.type,
                                        doc._id
                                      );
                                    }}
                                  />
                                  <span
                                    className="upload_image_holder"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <figure
                                      className="add_img"
                                      style={{
                                        margin: 0,
                                        width: "20px",
                                        height: "20px",
                                      }}
                                    >
                                      <img
                                        src="/static/images/edit2_icon.svg"
                                        alt="icon"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </figure>
                                  </span>
                                </label>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>
                      </div>
                    </Grid>
                  ))
                )}
              </Grid>
            </div> */}

            <div className="single_doc" style={{ marginTop: "40px" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} className="heading">
                  <Typography className="document_head" variant="h5">
                    Security Documents
                  </Typography>
                </Grid>
                {securityDocs.length === 0 ? (
                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      style={{
                        padding: "20px",
                        textAlign: "center",
                        color: "#666",
                      }}
                    >
                      No security documents available
                    </Typography>
                  </Grid>
                ) : (
                  securityDocs.map((doc, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                      key={doc._id || index}
                    >
                      <div className="control_group">
                        <Typography className="custom_label">
                          {getDocumentTypeLabel(doc.type, "security")}
                        </Typography>
                        <Box className="docs_div v2">
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <div
                                className="doc_preview_container"
                                style={{ position: "relative" }}
                              >
                                {renderDocumentPreview(doc)}
                                <label
                                  className="upload_image no_radius v2"
                                  htmlFor={`icon-button-file-security-${doc.type}-${doc._id}`}
                                  style={{
                                    position: "absolute",
                                    bottom: 8,
                                    right: 8,
                                    width: "32px",
                                    height: "32px",
                                    minWidth: "32px",
                                    padding: 0,
                                    borderRadius: "50%",
                                    backgroundColor: "rgba(255,255,255,0.9)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                  }}
                                >
                                  <Input
                                    sx={{ display: "none" }}
                                    id={`icon-button-file-security-${doc.type}-${doc._id}`}
                                    type="file"
                                    inputProps={{
                                      accept:
                                        "image/png,image/jpeg,application/pdf",
                                    }}
                                    onChange={(event: any) => {
                                      handleImageUpload(
                                        event,
                                        "security",
                                        doc.type,
                                        doc._id
                                      );
                                    }}
                                  />
                                  <span
                                    className="upload_image_holder"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <figure
                                      className="add_img"
                                      style={{
                                        margin: 0,
                                        width: "20px",
                                        height: "20px",
                                      }}
                                    >
                                      <img
                                        src="/static/images/edit2_icon.svg"
                                        alt="icon"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </figure>
                                  </span>
                                </label>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>
                      </div>
                    </Grid>
                  ))
                )}
              </Grid>
            </div>

            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={async () => {
                  // First submit basic info
                  await formik.handleSubmit();
                  if (Object.keys(formik.errors).length === 0) {
                    // Then submit documents
                    await handleSubmitDocuments();
                  }
                }}
              >
                {translation.globals.submit}
              </Button>
            </div>
          </div>
        </CustomTabPanel>
      </div>
      <ViewDocModal
        open={openDocView}
        onClose={() => setOpenDocView(false)}
        imageUrl={selectedDocUrl}
      />
      <PdfPreviewModal
        open={openPdfPreview}
        onClose={() => setOpenPdfPreview(false)}
        pdfUrl={selectedPdfUrl}
      />
    </MainContainer>
  );
};

export default AddTeam;
